/* eslint-disable react/jsx-no-target-blank */
import moment from 'moment';
import { formatPaymentStatus } from 'utils/paymentStatus';
import { formatCurrency } from 'react-data-formatter';
import { primary } from 'styles/colorProvider';
export const dataColumns = [
  {
    name: 'Proposta/Contrato',
    selector: (row) =>
      row?.is_unified_group_row ? (
        <span title="Cobrança consolidada de múltiplas apólices">Várias apólices (grupo)</span>
      ) : (
        <a
          style={{ color: primary }}
          target="_blank"
          href={
            row?.id_policy
              ? `/backoffice/detalhes-do-contrato/${row?.id_policy}`
              : `/backoffice/detalhes-da-proposta/${row?.id_proposal}`
          }
        >
          {row?.id_policy ? row?.code_ebao : `${row?.protocol?.slice(0, 19)}...`}
        </a>
      ),
    width: '15%',
    sortable: true,
  },
  {
    name: 'ID',
    selector: (row) => row?.id,
    width: '7%',
    sortable: true,
  },
  {
    name: 'Cliente',
    selector: (row) => row?.name_client,
    width: '15%',
    sortable: true,
  },
  {
    name: 'Tipo',
    selector: (row) => row?.type_charge,
    width: '10%',
    sortable: true,
  },

  {
    name: 'Valor',
    selector: (row) => formatCurrency(row?.value || 0),
    width: '10%',
    sortable: true,
  },
  {
    name: 'Status',
    selector: (row) => formatPaymentStatus(row?.status)?.label || 'Aguardando pagamento',
    width: '13%',
    sortable: true,
  },
  {
    name: 'Unificado',
    selector: (row) =>
      row?.is_unified ? (
        <a
          style={{ color: primary, fontWeight: 'bold' }}
          target="_blank"
          rel="noreferrer"
          href={row?.unified_invoice_url}
          title="Participa de boleto unificado — clique para ver o boleto"
        >
          Boleto Unificado
        </a>
      ) : (
        '-'
      ),
    width: '12%',
    sortable: true,
  },
  {
    name: 'Data cobrança',
    selector: (row) => moment(row?.created_at).format('DD/MM/YYYY'),
    width: '10%',
    sortable: true,
  },
  {
    name: 'Data vencimento',
    selector: (row) => moment(row?.due_at).format('DD/MM/YYYY'),
    width: '10%',
    sortable: true,
  },
  {
    name: 'Data pagamento',
    selector: (row) => (row?.paid_at ? moment(row?.paid_at).format('DD/MM/YYYY') : '-'),
    width: '10%',
    sortable: true,
  },
];
